import React from "react";
import { Layout, LARTokenWithdrawal } from "../components";
import "../assets/css/token.css";

const LARToken = () => {
  return (
    <>
      <Layout>
        <LARTokenWithdrawal />
      </Layout>
    </>
  );
};

export default LARToken;
